import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { postData } from '../../Services/apiService.js';
import { apiUrl } from '../../config/api.js';

const OTPVerification = () => {
    const { transactionID, ContactNo, EmailID, Fname } = useParams();
    const [otp, setOtp] = useState('');
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    console.log("transactionID", transactionID);
    const handleVerifyOtp = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            // Call API to verify OTP
            const result = await postData(apiUrl('VerifyOTP/'+ContactNo+'/'+otp), {
                ContactNo,
                EmailID,
                OTP: otp
            });
            console.log("transactionID", transactionID);
            if (result &&
  result.Status === 'Success') {
                // Proceed with registration
                navigate(`/verifyRegistration/${transactionID}/${Fname}/${ContactNo}/${EmailID}`);
            } else {
                
                alert('Invalid OTP. Please try again.');
            }
        } catch (error) {
            alert('Error verifying OTP');
        }
        setLoading(false);
    };

    return (
        <div className="my-appl-box">
        <div className="container mt-5">
            <h2>OTP Verification</h2>
            <form onSubmit={handleVerifyOtp}>
                <div className="mb-3">
                    <label htmlFor="otp" className="form-label">Enter OTP</label>
                    <input
                        type="text"
                        className="form-control"
                        id="otp"
                        value={otp}
                        onChange={(e) => setOtp(e.target.value)}
                        required
                    />
                </div>
                <button type="submit" className="btn btn-primary" disabled={loading}>
                    {loading ? 'Verifying...' : 'Verify OTP'}
                </button>
            </form>
        </div>
    </div>
    );
};

export default OTPVerification;
